module.exports = __webpack_public_path__ + "media/images/lb/884-26afa20a0f0aedfbeababd4dfed6f5ad.svg";